/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

jQuery(function ($) {
    $('document').ready(setup);
    $(window).on('load', documentReady);

    function setup() {

        /* -- Déplacement des élements vers l'encart sidebar sur les pages pôles -- */
        if ($('main #sidebar-section').length) {
            $('main .custom-block-content .secondary-section').append($('main #sidebar-section > div.block-plus-infos'));
            $('main #sidebar-section > div.block-pub-poster').each(function () {
                $('main .custom-block-content .secondary-section').append($(this));
            });
        }

        $('.navigation #block-lang-selection .links > li > a').each(function () {
            $(this).text($(this).text().substr(0, 2));
        });

        $('.navigation:not(.mobile-nav) .blocksearch-block-form form .form-actions input').click(function (e) {
            var size = $(this).parents('form').css('width');
            var parent = $(this).parents('form');
            var value = parent.find('input#edit-keys').val();
            if (size !== '0px') {
                parent.css('width', '0');
                parent.find('input#edit-keys').css('transform', 'translate(200px, -5px)');
                if (value === "") {
                    e.preventDefault();
                } else {
                    return;
                }
            } else {
                e.preventDefault();
                parent.css('width', '140px');
                parent.find('input#edit-keys').css('transform', 'translate(0, -5px)');
                return;
            }
        });

        $('.js-show-header-video').click(function (e) {
            e.preventDefault();
            $('.video-modal').addClass('visible');
            $('.video-modal a').click(function () {
                $('.video-modal').removeClass('visible');
                callPlayer("header-video", "stopVideo");
            });
        });

        $('.js-scrollTo').on('click', function(e) {
            e.preventDefault();
            var position = $($(this).attr("href")).offset().top;
            $('html, body').animate({
                scrollTop: position - 100,
            }, 1500);
        });

        $(window).scroll(function() {
            if($(window).scrollTop() > 100) {
                $('.navigation:not(.mobile-nav)').addClass('scrolled');
            } else if ($(window).scrollTop() == 0) {
                $('.navigation:not(.mobile-nav)').removeClass('scrolled');
            }
            animateNumbers();
        });

        $('#block-resultatdelarecherchepourlentityexposant .advanced-search form > button, #block-resultatdelarecherchepourlentityproduit .advanced-search form > button, #block-resultatdelarecherchepourlentitydemonstration .advanced-search form > button').click(function (e) {
            e.preventDefault();
            $('.advanced-search').toggleClass('collapse');
            $('.all-entity-link').toggleClass('visually-hidden');
        });

        $('#js-list a.print-exhibitor-list').click(function(e) {
            e.preventDefault();
            // var page = $('.dialog-off-canvas-main-canvas');
            // var section_printable = $('main .main-section');
            // page.before(section_printable);
            // section_printable.css('padding', '50px');
            // page.hide();
            // window.print();
            // $('.secondary-section', page).before(section_printable);
            // section_printable.css('padding', '0');
            // page.show();
        });

        $('a.print-exhibitor').click(function(e) {
            e.preventDefault();
            var page = $('.dialog-off-canvas-main-canvas');
            var section_printable = $('main .exhibitor-content, main .exhibitor-product-list');
            page.before(section_printable);
            $('a.btn', section_printable).hide();
            section_printable.css('padding', '50px');
            // section_printable.prepend($('#block-logo'));
            // section_printable.prepend($('.exhibitor-logo'));
            // $('#block-logo').css('float', 'right');
            page.hide();
            window.print();
            $('.header-exhibitor', page).after(section_printable);
            section_printable.css('padding', '0');
            // $('.navigation:not(.mobile-nav)').prepend($('#block-logo'));
            // $('.header-exhibitor').prepend($('.exhibitor-logo'));
            // $('#block-logo').css('float', 'inherit');
            $('a.btn', section_printable).show();
            page.show();
        });

        // A commenter lors du renseignement des véritables url dans le bloc pictogrammes
        // $('.list-picto a').click(function (e) {
        //     e.preventDefault();
        //     var anchor = $(this).attr('href');
        //     if (anchor === '#') {
        //         return;
        //     }
        //     $('html, body').animate({
        //         scrollTop:$(anchor).offset().top-120
        //     }, 'slow');
        //     return false;
        // });

        /* -- Navbar - Burger menu -- */

        $('.mobile-nav #block-formulairederecherche').addClass('visually-hidden');

        $('.navigation:first-of-type .icon-menu').click(function (e) {
            e.preventDefault();
            if ( $(this).hasClass('icon-search') ) {
                $('.mobile-nav #block-formulairederecherche').toggleClass('visually-hidden');
            }
            $('.mobile-nav').addClass('show-header');
            $('header, main').click(function () {
                $('.mobile-nav').removeClass('show-header');
            });

            $('.mobile-menu-header .icon-close-menu').click(function () {
                $('.mobile-nav').removeClass('show-header');
            });
        });

        $('.mobile-nav #block-navigationprincipale ul.nav-link-list > li.collapsible').click(function () {
            $(this).toggleClass('collapsed');
        });

        /* -- Modal -- */

        $('.plan-pole .js-show-modal, .plan-pole .close-modal, .modal-overlay:not(.file-download)').click(function (e) {
            e.preventDefault();
            $('.modal-overlay:not(.file-download)').toggleClass('visible');
            $('.plan-pole .modal').toggleClass('visible');
            if ($('.plan-pole .modal').hasClass('visible')) {
              $('.modal-logo-container').slick({
                slidesToShow: 5,
                slidesToScroll: 5,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                accessibility: false,
                draggable: false,
                responsive: [
                  {
                    breakpoint: 760,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      autoplaySpeed: 3000,
                    }
                  },
                ],
              });
            }
        });

        $('a.share-social').click(function (e) {
            e.preventDefault();
            $('ul.social-links').toggleClass('hidden');
        });

        $('.block-file-download > a, .modal-overlay.file-download').click(function (e) {
            e.preventDefault();
            $('.block-file-download .modal-overlay').toggleClass('visible');
            $('.block-file-download .modal').toggleClass('visible');
        });

        $('.modal a.js-sendFilesByMail').click(function (e) {
            e.preventDefault();
            var email = prompt('Renseignez votre email');
            if (email != null) {
                window.location.href = '/cart/sendByMail?email='+email;
            }
        });

        $('.modal .modal-content .file-list li > a.js-delete-file').click(function () {
            var deleted = $(this);
            $.post("/cart/removeFile", {file: $(this).attr('data-file')}).done(function() {
                deleted.parent().remove();
                var nb_files = parseInt($('.block-file-download .tag-nb-files span').text());
                if (nb_files === 1) {
                    $('.tag-nb-files').hide();
                } else {
                    $('.tag-nb-files span').text(nb_files - 1);
                }

                // $('body').toggleClass('loader');
            }).fail(function() {
                console.error('Votre fichier n\'a pas pu être retiré du parcours de viste');
            });
        });


        /* Autocomplete county select */
        $('.webform-submission-reservation-stand-form .webform-button--next').click(function () {
            setTimeout(function () {
                if (!location.pathname.match(/.*en/)) {
                    $('.js-form-wrapper[data-webform-key="step_2"] .form-item-address-country .form-select option[selected="selected"]').attr('selected', false);
                    $('.js-form-wrapper[data-webform-key="step_2"] .form-item-address-country .form-select option[value="France"]').attr('selected', true);
                }
            }, 2000);
        });

        $('form input.form-submit').submit(function () {
            setTimeout(function () {
                if ($('.form-item-rgpd', $(this))) {
                    $('.form-item-rgpd .description').css('color', '#fb7401');
                }
            }, 1000);
        });


        /* Comportement réveal phone */
        $('.phone-contact .btn').click(function (e) {
            if (window.matchMedia("(max-width: 767px)").matches) {
                return;
            } else {
                e.preventDefault();
                $('span', $(this)).text($(this).attr('data-phone'));
            }
        });

        /* Drupal Status Messages */
        $('div[data-drupal-messages] .messages').click(function () {
            $(this).parent().css('transform', 'translateX(150%)');
        });

    }

    function documentReady() {

        countTime();
        trackEvent();
        homeSlider();
        blockPartners();
        blockPartnersView();
        blockPoles();
        initBlockVideo();
        initBlockFaq();


        // Remove alert on top of newsletter form on submit
        var form = $('form.webform-submission-newsletter-form');
        $('.form-submit', form).click(function () {
            setTimeout(function () {
                submitForm();
            }, 2000);
        });

        if ($('#map').length > 0) {
            initMap();
        }

        if ($('.pole-content .js-show-modal').length === 0) {
            $('.block-file-download').hide();
        } else {
            $('.btn-visit').parent().hide();
        }

        if ($('form.webform-submission-formulaire-cirq-form #edit-etape-2').length > 0) {
          $('form.webform-submission-formulaire-cirq-form #edit-actions-wizard-next').click(function () {
            var description_produit = $('textarea[name="description_de_l_innovation_text"]').val();
            setCookie('description_produit',description_produit,1);
          });

        }

        if ($('form.webform-submission-formulaire-cirq-form #edit-etape-3').length > 0) {
          $('#edit-quelles-sont-la-ou-les-performances-environnementales-majeures-a .form-checkboxes .form-item').each(function () {
            var parent = $(this);
            showSubCheckbox(parent, $('input[type="checkbox"]', parent).val());
          });
        }

        if ($('form.webform-submission-formulaire-cirq-form #edit-etape-4').length > 0) {
          var description_innovation = getCookie('description_produit');
          $('textarea[name="description_synthetique_de_l_innovation"]').val(description_innovation);
          eraseCookie('description_produit');
        }

        animateNumbers();

        // if ($('.block-slider').length > 0) {
          /*$('.slick-slider').on('init reInit beforeChange', function(){
            $('.block-slider .slider-arrow').addClass('active');
          });*/

          $('.logo-container').slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            accessibility: false,
            draggable: false,
            responsive: [
              {
                breakpoint: 760,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  autoplaySpeed: 3000,
                }
              },
            ],
          });

          $('.list-item-gallery.slider ul').slick({
            dots: false,
            appendArrows: $('.block-gallery .slider-arrow'),
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#icone-fleche-droite"></use></svg><span class="sr-only">Evenement précédent</span></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#icone-fleche-droite"></use></svg><span class="sr-only">Evenement suivant</span></button>',
            adaptiveHeight: false,
            variableWidth: true,
          });

          $('.list-testimonials.slider ul').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: false,
            nextArrow: false,
            dots: true,
            adaptiveHeight: true
          });

          $('.list-citations.slider ul').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: false,
            nextArrow: false,
            dots: true,
            responsive: [
              {
                breakpoint: 1080,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 760,
                settings: {
                  slidesToShow: 1,
                }
              },
            ],
          });

          /*$('.top-exhibitors .logo-container').slick({
            // lazyLoad: 'ondemand',
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: true,
            speed: 5000,
            prevArrow: false,
            nextArrow: false,
            dots: false,
            responsive: [
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                }
              },
              {
                breakpoint: 760,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                }
              },
            ],
          });*/

          $('.slick-slider').not('.slick-initialized').slick({
            // lazyLoad: 'ondemand',
            dots: false,
            appendArrows: $('.block-slider .slider-arrow'),
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#icone-fleche-droite"></use></svg><span class="sr-only">Evenement précédent</span></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#icone-fleche-droite"></use></svg><span class="sr-only">Evenement suivant</span></button>',
            adaptiveHeight: true,
            // prevArrow: false,
            // nextArrow: false,
            // infinite: true,
            // speed: 300,
            // slidesToShow: 1,
            // centerMode: true,
            // variableWidth: true,
            // autoplay: true,
            // autoplaySpeed: 5000,
          });
        // }

        /*if ($('#block-prenavigation li a.btn-visit').length > 0) {
            $('li.button .btn-visit').html("<span>"+ $(this).text() +"</span>");
            /!*var xhr = new XMLHttpRequest;
            xhr.open('get',window.location.hostname+'/themes/custom/artibat/images/icone-parcours-plus.svg',true);
            xhr.onreadystatechange = function(){
                if (xhr.readyState != 4) return;
                var svg = xhr.responseXML.documentElement;
                svg = document.importNode(svg,true); // surprisingly optional in these browsers
                document.body.appendChild(svg);
            };
            xhr.send();*!/
            var icon = $('<img/>').addClass('icon icon-visit');
            var icon_src = window.location.hostname+'/themes/custom/artibat/images/icone-parcours-plus.svg';
            icon.attr('src', icon_src);
            $('li.button .btn-visit').prepend(icon);
        }*/

        // NEWSLETTER AJAX FORM
        /*$(".newsletter-social form").submit(function(){
            if($('#gdpr_newsletter').prop('checked')){
                var regex_email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var email = $('#email-newsletter').val();
                var confirmation_page = $('.newsletter-social form').attr('action');

                if(regex_email.test(String(email).toLowerCase())){
                    $.ajax({
                        type: "POST",
                        url: '/fr/ajax/newsletter',
                        data: 'email=' + email,
                        async: true
                    }).done(function(data){
                        if(data.code == 200)
                            window.location.replace(confirmation_page);
                        else
                            alert('There was an error with the email submission.')
                    });
                }
                else{
                    alert($('#email-newsletter').data('error_msg'));
                }
            }
            /!*else{
                alert($('#gdpr_newsletter').data('error_msg'));
            }*!/
            return false;
        });*/

    }

    function animateNumbers(container) {
      $('.numbers .orange-title-MS').each(function () {
        if (window.innerHeight + window.scrollY > $(this).offset().top - 100) {
          $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
          }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
              $(this).text(Math.ceil(now));
            }
          });
        }
      });
    }

    function setCookie(name,value,days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
    }

    function eraseCookie(name) {
      document.cookie = name+'=; Max-Age=-99999999;';
    }

    function showSubCheckbox(parent, value) {
      $('form.webform-submission-formulaire-cirq-form #edit-etape-3 #edit-performances-environnementales > .fieldset-wrapper > fieldset').each(function () {
        if ($(this).hasClass(value)) {
          $(this).detach().appendTo(parent);
          $(this).css('padding-left', '15px');
          $('.form-checkboxes', $(this)).css('margin-top', '0');
        }
      });
    }

    function submitForm() {
        var form = $('form.webform-submission-newsletter-form');
        var nb_alert = $('div[role="contentinfo"]', form).length;
        $('.form-submit', form).css('margin-top', (nb_alert*42)+15+'px');
        $('div[role="contentinfo"]', form).each(function () {
            setTimeout(function () {
                $('div[role="contentinfo"]', form).remove();
                $('.form-submit', form).css('margin-top', '15px');
            }, 3000);
        });
    }

    function countTime() {
        var date_actuelle = new Date();
        var date_evenement = new Date("Oct 22 00:00:00 2025");
        var total_secondes = (date_evenement - date_actuelle) / 1000;
        var jours = Math.floor(total_secondes / (60 * 60 * 24));
        if (jours > 0) $('header .js-count > span').text("J - "+jours);
        else $('header .js-count > span').text("J - 0");
    }

    // Fonction d'initialisation de la carte
    function initMap() {
        var width = $('#map').parent().parent().width();
        var height = $('#map').parent().parent().height();

        $('#map').css({"width": width, "height": height});

        var lat = '48.0574196';
        var lon = '-1.731611';
        // Créer l'objet "macarte" et l'insèrer dans l'élément HTML qui a l'ID "map"
        macarte = L.map('map', {
                dragging: !L.Browser.mobile,
                scrollWheelZoom: false,
                scrollWheelPan: true
            }
        ).setView([lat, lon], 11);
        // Leaflet ne récupère pas les cartes (tiles) sur un serveur par défaut. Nous devons lui préciser où nous souhaitons les récupérer. Ici, openstreetmap.fr
        L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
            // Il est toujours bien de laisser le lien vers la source des données
            attribution: 'Map data OSM FR © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            minZoom: 6,
            maxZoom: 18
        }).addTo(macarte);

        var myIcon = L.icon({
            iconUrl: "/themes/custom/artibat/images/icone-localisation.svg",
            iconSize: [48, 48],
            iconAnchor: [25, 50],
            popupAnchor: [-3, -76],
        });

        var marker = L.marker([lat, lon], { icon: myIcon }).addTo(macarte).bindPopup("<span>Parc des Expositions</span>"/*: { "lat": lat, "lon": lon }*/).openPopup();
    }

    /*
     * @author       Rob W (http://stackoverflow.com/a/7513356/938089
     * @description  Executes function on a framed YouTube video (see previous link)
     *               For a full list of possible functions, see:
     *               http://code.google.com/apis/youtube/js_api_reference.html
     * @param String frame_id The id of (the div containing) the frame
     * @param String func     Desired function to call, eg. "playVideo"
     * @param Array  args     (optional) List of arguments to pass to function func*/
    function callPlayer(frame_id, func, args) {
        if (window.jQuery && frame_id instanceof jQuery) frame_id = frame_id.get(0).id;
        var iframe = document.getElementById(frame_id);
        if (iframe && iframe.tagName.toUpperCase() != 'IFRAME') {
            iframe = iframe.getElementsByTagName('iframe')[0];
        }
        if (iframe) {
            // Frame exists,
            iframe.contentWindow.postMessage(JSON.stringify({
                "event": "command",
                "func": func,
                "args": args || [],
                "id": frame_id
            }), "*");
        }
    }

    function trackEvent() {
      $(".btn[data-tracking='badge']").each(function() {
        $(this).click(function() {
          gtag('event', 'badge', {
            badge_location: window.location.pathname
          })
        })
      })
      $(".btn[data-tracking='download_map']").click(function() {
        gtag('event', 'download_map', {})
      })
      $("a[data-tracking='download_parcours']").click(function() {
        gtag('event', 'download_parcours', {})
      })
      $(".btn[data-tracking='form_submission']").click(function() {
        gtag('event', 'form_submission', {
          form: 'parcours_visite'
        })
      })
      $(".webform-submission-newsletter-form input[type='submit']").each(function() {
        $(this).click(function() {
          gtag('event', 'form_submission', {
            form: 'newsletter'
          })
        })
      })
    }

    function homeSlider() {

      if($('.header-home')[0]){

      $('.header-slider .field_slider_media').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          autoplay: true,
          autoplaySpeed: 5000,
          appendArrows: $('.header-slider .slider-arrow'),
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropLeft"></use></svg><span class="sr-only">Slide précédente</span></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropRight"></use></svg><span class="sr-only">Slide suivante/span></button>',
      });
      }
    }

    function blockPartners() {
      $('.paragraph--type--bloc-partners .partners-slider').slick({
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        appendArrows: $('.paragraph--type--bloc-partners .slider-arrow'),
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropLeft"></use></svg><span class="sr-only">Slide précédente</span></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropRight"></use></svg><span class="sr-only">Slide suivante/span></button>',
        arrows: true,
        accessibility: true,
        draggable: true,
        variableWidth: true
        // responsive: [
        //   {
        //     breakpoint: 760,
        //     settings: {
        //       slidesToShow: 2,
        //       slidesToScroll: 1,
        //       autoplaySpeed: 3000,
        //     }
        //   },
        // ],
      });
    }

  function blockPartnersView() {
    $('#block-partenaires-slider .view-partenaires').slick({
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      appendArrows: $('#block-partenaires-slider .slider-arrow'),
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropLeft"></use></svg><span class="sr-only">Slide précédente</span></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropRight"></use></svg><span class="sr-only">Slide suivante/span></button>',
      arrows: true,
      accessibility: true,
      draggable: true,
      variableWidth: true
      // responsive: [
      //   {
      //     breakpoint: 760,
      //     settings: {
      //       slidesToShow: 2,
      //       slidesToScroll: 1,
      //       autoplaySpeed: 3000,
      //     }
      //   },
      // ],
    });
  }
    function blockPoles() {
      $('.block-activity .list-pole > ul').slick({
        slidesToScroll: 1,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 5000,
        draggable: true,
        arrows: true,
        appendArrows: $('.block-activity .slider-arrow'),
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropLeft"></use></svg><span class="sr-only">Slide précédente</span></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg class="icon icon-arrow"><use xlink:href="/themes/custom/artibat/images/sprites.svg#ArrowDropRight"></use></svg><span class="sr-only">Slide suivante/span></button>',
        variableWidth: true,
      });
    }

  /**
   * Block video
   */
  function initBlockVideo() {
    $("body").on(
      "click touch",
      ".block-video .block-video-embed--link",
      function (e) {
        e.preventDefault();
        $(this)
          .closest(".block-video")
          .find(".block-video-embed--content")
          .html(
            '<iframe src="' +
            $(this).attr("href") +
            '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>'
          );
        $(this)
          .closest(".block-video")
          .addClass("play");
      }
    );
  };

  /*
   * Block FAQ
   */
  function initBlockFaq() {
    $("body").on(
      "click touch",
      ".paragraph--type--block-faq .field_question",
      function (e) {
        e.preventDefault();
        $(this).addClass("selected");
        $(this)
          .closest(".paragraph--type--block-faq")
          .find(".field_question:not(.selected)")
          .removeClass("active");
        $(this).removeClass("selected").toggleClass("active");
      }
    );
  };

}(jQuery));

window.displayLoader = function (bool) {
    if (bool) {
        $("body").removeClass("loading");
    } else {
        $("body").addClass("loading");
    }
};
